import { Typography } from "@circle-react-shared/uikit/Typography";

interface EventsDateDividerProps {
  current: string;
  previous: string;
}

export const EventsDateDivider = ({
  current,
  previous,
}: EventsDateDividerProps) => {
  const currentDate = new Date(current);
  const previousDate = new Date(previous);
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.toLocaleString("en-US", { month: "long" });

  const previousYear = previousDate.getFullYear();
  const previousMonth = previousDate.toLocaleString("en-US", { month: "long" });

  if (currentYear !== previousYear || currentMonth !== previousMonth) {
    return (
      <div className="bg-secondary p-4">
        <Typography.LabelSm color="text-tertiary" weight="normal" truncate>
          {currentMonth} {currentYear}
        </Typography.LabelSm>
      </div>
    );
  }
  return null;
};
